export default __webpack_public_path__ + "static/media/Tunic of the Death God.54310b08.jpg";